import * as Types from "./Types";
import { createInitialProductInput, normalizeProductForForm } from "./productUtils";

const initialState = {
  productList: null,
  productInput: createInitialProductInput(),
  isCreateProduct: false,
  afterUpdate: false,
  isIconLoading: false,
  isImgLoading: false,
  isListLoading: false,
};

const ProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.GET_PRODUCT_INPUT: {
      const productInput = { ...state.productInput };
      productInput[action.payload.name] = action.payload.value;
      return {
        ...state,
        productInput,
      };
    }
    case Types.PRODUCT_LIST:
      return {
        ...state,
        productList: action.payload,
      };
    case Types.IS_CREATE_PRODUCT:
      return {
        ...state,
        isCreateProduct: action.payload,
      };
    case Types.AFTER_CREATE_PRODUCT:
      return {
        ...state,
        productInput: createInitialProductInput(),
      };
    case Types.AFTER_UPDATE_PRODUCT:
      return {
        ...state,
        afterUpdate: action.payload,
      };
    case Types.ICON_LOADING:
      return {
        ...state,
        isIconLoading: action.payload,
      };
    case Types.IMG_LOADING:
      return {
        ...state,
        isImgLoading: action.payload,
      };
    case Types.IS_PRODUCT_LIST_LOADING:
      return {
        ...state,
        isListLoading: action.payload,
      };
    case Types.PRE_UPDATE_PRODUCT:
      return {
        ...state,
        productInput: normalizeProductForForm(action.payload),
      };
    default:
      return state;
  }
};

export default ProductReducer;
